import React from "react";
import {Link} from "react-router-dom";

import Grid from "@mui/material/Unstable_Grid2";
// import {Icon} from "@mui/material";

import {RSTLogo} from './icons/icons';
// import NichdIcon from "./img/nichd-logo-short.jpg";
// import SearchIcon from "@mui/icons-material/Search";

import MaintenanceBanner from "./maintenance/maintenance-banner";

const MainHeader = (props) => {

    React.useEffect(() => {
       console.log(props.maintenanceBanner);
    });

    return ( <header className='top-matter' style={{ width: '100%' }}>
        {props.maintenanceBanner === 'true' &&
            <MaintenanceBanner/>
        }

        <Grid xs={12} container>
            <Grid id="header-logo" style={{marginTop:'18px'}}>
                <Link to={'/'}>
                    <RSTLogo aria-label="Data Repository Finder" />
                </Link>
            </Grid>

            <Grid xs={7} style={{ position: 'relative'}}>
                <p id="header-text">
                    <b>Data Repository Finder</b> helps NICHD researchers find data repositories where
                    they can share data as they develop and implement their NIH Data Management and Sharing Plans.
                    Repositories are added on an ongoing basis.
                </p>
            </Grid>

            {/* Removing the NICHD logo at sponsor's request
            <Grid>
                <Icon sx={{float: 'right', alignContent: 'center', height: 50, width: 50}}>
                    <img src={NichdIcon} alt='NICHD Icon' height={50} width={50} />
                </Icon>
            </Grid>*/}
        </Grid>
    </header> );
};

export default MainHeader;